import {  useState } from "react";

import {  useDisclosure } from "@chakra-ui/react";

import { getLeadName } from "../../Config/leadStatus";
import {  getDateFormat } from "../../Config/functions";
import { FaWhatsapp } from "react-icons/fa";
import { SendAppDownloadNotificationModal } from "../Modals/SendAppDownloadNotificationModal";
import { DateTime } from "luxon";

export const SingleTestAssessment = ({ props ,func}: any) => {
 
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { id, data, createdAt } = props;
  const [leadStatus] = useState(data.new_lead_status);
  const [modal, setModal] = useState("");

  const message = data.message_history;

  function formatDateWithOffset(isoString:string) {

    let date = DateTime.fromISO(isoString, { zone: 'utc' });

    date = date.plus({ hours: 5, minutes: 30 });

    return date.toFormat('dd-MMM-yy');
}

  return (
    <tr>
      <td>{data.client_information.name}</td>
      <td>{formatDateWithOffset(createdAt)}</td>
      <td>{leadStatus && leadStatus != "" ? getLeadName(leadStatus) : ""}</td>
      <td>
        {message && message.length > 0
          ? `${getDateFormat(message[0].date.split("/")[0])}-${
              message[0].date.split("/")[1]
            }`
          : ""}
      </td>
      <td>
        <div>
          <span title="Whatsapp notification">
            <FaWhatsapp
              className="button-icon pointer"
              onClick={() => {
                setModal("downloadAppNotification");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>
      {modal === "downloadAppNotification" && (
        <SendAppDownloadNotificationModal
          isOpen={isOpen}
          onClose={onClose}
          row={props}
          func={func}
          id={id}
        />
      )}
    </tr>
  );
};
